import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAppSelector } from "../../stores";
import { Endpoints } from "../index";
const ProtectedRoute = () => {
    const location = useLocation();
    const currentUser = useAppSelector(state => state.auth.currentUser);
    const isAuthenticated = currentUser !== null;
    if (isAuthenticated) {
        return _jsx(Outlet, {});
    }
    return _jsx(Navigate, { to: Endpoints.ROOT, state: { from: location }, replace: true });
};
export default ProtectedRoute;
